/**
 * @generated SignedSource<<f82a38a13ec8aa6c49b606edab960199>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stoererId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "stoererId"
      }
    ],
    "concreteType": "Stoerer",
    "kind": "LinkedField",
    "name": "stoerer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text_headline",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text_intro",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text_content",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text_style",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "image_url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "image_link",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "button_type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "close_type",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoererPreviewQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoererPreviewQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "60ded8d06e5934b5001cd3773ebb0b76",
    "id": null,
    "metadata": {},
    "name": "StoererPreviewQuery",
    "operationKind": "query",
    "text": "query StoererPreviewQuery(\n  $stoererId: Int!\n) {\n  stoerer(id: $stoererId) {\n    type\n    text_headline\n    text_intro\n    text_content\n    text_style\n    image_url\n    image_link\n    button_type\n    close_type\n  }\n}\n"
  }
};
})();

node.hash = "87b027ba43ee78a46b42b0358615275d";

module.exports = node;
